import { render, staticRenderFns } from "./LecturaQR.vue?vue&type=template&id=19d32a94&scoped=true"
import script from "./LecturaQR.vue?vue&type=script&lang=js"
export * from "./LecturaQR.vue?vue&type=script&lang=js"
import style0 from "./LecturaQR.vue?vue&type=style&index=0&id=19d32a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d32a94",
  null
  
)

export default component.exports